import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import BaseChartCard from '../base-chart-card';
import Divider from '../../../../../../../core/layout-components/divider';
import TimeOnQuestion from '../time-on-question';

const QuestionChart = (props) => {
  const {
    data, title, projectId,
  } = props;

  const {
    id,
    label,
    questionOrder,
    writtenAndTranscriptAnswers,
    averageTime,
  } = data;

  return (
    <BaseChartCard
      questionTitle={`Question ${questionOrder + 1}`}
      questionLabel={label}
      questionType={title}
      questionId={id}
    >
      <Divider />
      {!_.isEmpty(writtenAndTranscriptAnswers) && (
        <TimeOnQuestion
          data={writtenAndTranscriptAnswers}
          averageTime={averageTime}
          projectId={projectId}
        />
      )}

    </BaseChartCard>
  );
};

QuestionChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string,
    questionOrder: PropTypes.number,
    writtenAndTranscriptAnswers: PropTypes.arrayOf(PropTypes.shape),
    averageTime: PropTypes.number,
  }).isRequired,
  projectId: PropTypes.string.isRequired,
};

export default QuestionChart;
